import React, { useState  } from 'react'
import { Grid , Typography  , FormHelperText , TextareaAutosize} from '@mui/material'
import CustomButton from '../../../shared/CustomButton'
import { MentionsInput, Mention } from 'react-mentions'
import { inputStyles , mentionStyles } from '../../../../utils/MentionStyle';
const SubscriberForm = ({disputeRules,  setFieldValue , action , errors , success , error,
  index , alert ,
   setValues , values,  
   setDirty,
   setIsConfirmationModalOpen,
   dirty,
   
 }) => {
/* 
  let templateVariables = [
    {
  id:7,
  display:"ReferenceNumber"
    },
    {id:1,
      display:"RelatedReference"
     },
     {id:2,
       display:"MTNumber"
      },
      {
       id:3,
       display:"CustomerID"
      },
      {
       id:4,
       display:"CustomerName"
      },
      {
       id:5,
       display:"GroupName"
      },
   
    {
       id:6,
       display:"AlertSet"
      },
    ]
   */

  

    const [templateText,setTemplateText]=useState(alert.text)





const handleChange = (e) => {
  
    setTemplateText(e.target.value)

    const newTemplatesText = {
      ...values,
        text:e.target.value
      

    }

    setValues(newTemplatesText)

    setDirty(true)
} 


  return (
    <>

    <Typography
      sx={{
        color: "#050D2E",
        fontSize: ".875rem",
        fontWeight: "bold",
        lineHeight: "21px",
        marginBottom: "5px",
        marginTop:"30px"
      }}
    >
Email/SMS template
    </Typography>

{/*      <TextareaAutosize
value={templateText || ""}
onChange={(e) => handleChange(e)}
style={{ 
  minWidth:600 ,
  maxWidth:600, 
  height:"200px",
  overflow:"auto",
   border:"1px solid #DBDEE6", borderRadius: "4px" , resize:"none" ,
  fontFamily: "Roboto",
  fontSize:"14px",
  lineHeight:"1.5"
  }}rezie="none"
/> 
 */}
<MentionsInput value={templateText} 
onChange={ (e) => handleChange(e)}
style={inputStyles}
sx={{}}
>
   <Mention
   
  /> 
 
</MentionsInput> 
{Object.keys(errors).length > 0 && (
              <FormHelperText  error={true}>
                {errors.text}
              </FormHelperText>
            )}
<div>
<CustomButton
                    text="Save Template"
                    processing={false}
                    disabled={!dirty}
                    type="dark"
                    action={action}
                  />
</div>
   

  </>
  )
}

export default SubscriberForm